/**
 @since: 2020-04-06
 @author: tams_dev1
 */
import resultFactory from '~/utils/resultFactory'

export const state = () => ({
  url: '/api/po/qos/profiles',
  cmUrl: '/api/cm/fw-rule/page',
  selPolicyTab: 'ipv4',
  selectDeviceSet: null, // TAMS 선택한 장비 정보
  deviceTxt: '',
  qosIpv4FirewallList: [],
  qosIpv6FirewallList: [],
  qosQueueFirewallSetList: [],
  qosQueueFirewallList: []
})

export const mutations = {
  setDeviceText (state, payload) {
    if (payload === window.$nuxt.$t('da.noSelectedDevice')) {
      state.selectDeviceSet = null
    }
    state.deviceTxt = payload
  },
  initQoSQueueFirewall (state) {
    state.qosIpv4FirewallList = []
    state.qosIpv6FirewallList = []
    state.qosQueueFirewallSetList = []
    state.qosQueueFirewallList = []
  },
  setSelPolicyTab (state, data) {
    state.selPolicyTab = _.cloneDeep(data)
  },
  setDeviceSet (state, data) { // 선택한 장비 정보 저장
    state.selectDeviceSet = _.cloneDeep(data) // 선택한 장비 정보
  },
  getQoSIpv4FirewallList (state, data) {
    state.qosIpv4FirewallList = Object.freeze(data)
  },
  getQoSIpv6FirewallList (state, data) {
    state.qosIpv6FirewallList = Object.freeze(data)
  },
  getQoSQueueFirewallSetList (state, data) {
    state.qosQueueFirewallSetList = Object.freeze(data)
  },
  getQoSQueueFirewallList (state, data) { // [Queue에 포함된 목록] 조회
    state.qosQueueFirewallList = Object.freeze(data)
  },
  // [Queue에 포함된 목록]에 단일 추가
  addQoSQueueFirewall (state, data) {
    const cloneQosFirewallList = state.selPolicyTab === 'ipv4' ? _.cloneDeep(state.qosIpv4FirewallList) : _.cloneDeep(state.qosIpv6FirewallList)
    _.forEach(cloneQosFirewallList, (item) => {
      if (item.fw_rule_id === data.rid) {
        item.qos_class_name = _.cloneDeep(data.qos_class_name)
      }
    })
    if (state.selPolicyTab === 'ipv4') {
      state.qosIpv4FirewallList = Object.freeze(cloneQosFirewallList)
    } else {
      state.qosIpv6FirewallList = Object.freeze(cloneQosFirewallList)
    }
  },
  // [Queue에 포함된 목록]에 여러개 추가
  addQoSQueueFirewallList (state, data) {
    let cloneQosFirewallList = state.selPolicyTab === 'ipv4' ? _.cloneDeep(state.qosIpv4FirewallList) : _.cloneDeep(state.qosIpv6FirewallList)
    const cloneQosQueueFirewallList = _.cloneDeep(state.qosQueueFirewallList)
    _.forEach(data.fw_rule_id_list, (item) => {
      let dupCheck = false
      if (_.findIndex(cloneQosQueueFirewallList, {fw_rule_id: item.fw_rule_id}) > -1) {
        dupCheck = true
      }
      if (!dupCheck) {
        cloneQosFirewallList = _.map(cloneQosFirewallList, (clone) => {
          if (clone.fw_rule_id === item.fw_rule_id) {
            clone.qos_class_name = _.cloneDeep(data.qos_class_name)
          }
          return clone
        })
      }
    })
    if (state.selPolicyTab === 'ipv4') {
      state.qosIpv4FirewallList = Object.freeze(cloneQosFirewallList)
    } else {
      state.qosIpv6FirewallList = Object.freeze(cloneQosFirewallList)
    }
    state.qosQueueFirewallList = Object.freeze(cloneQosQueueFirewallList)
  },
  // [Queue에 포함된 목록] 삭제
  delQoSQueueFirewall (state, data) {
    let cloneQosFirewallList = state.selPolicyTab === 'ipv4' ? _.cloneDeep(state.qosIpv4FirewallList) : _.cloneDeep(state.qosIpv6FirewallList)
    _.forEach(data, (item) => {
      cloneQosFirewallList = _.map(cloneQosFirewallList, (clone) => {
        if (clone.fw_rule_id === item.fw_rule_id) {
          clone.qos_class_name = ''
        }
        return clone
      })
    })
    if (state.selPolicyTab === 'ipv4') {
      state.qosIpv4FirewallList = Object.freeze(cloneQosFirewallList)
    } else {
      state.qosIpv6FirewallList = Object.freeze(cloneQosFirewallList)
    }
  }
}

export const actions = {
  async getQoSFirewallList ({ commit, state }, {pid, did, ipVersion, loadingShow = true, loadingHide = true}) {
    const uri = `${state.url}/${pid}/queues/fw/${ipVersion}/devices/${did}`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      const selectMutation = ipVersion === '1' ? 'getQoSIpv4FirewallList' : 'getQoSIpv6FirewallList'
      return resultFactory(commit, {length: null, data: data, action: selectMutation, param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // [Queue에 포함된 목록] (상위 목록) 조회
  async getQoSQueueFirewallSetList ({ commit, state }, {pid, qid, loadingShow = true, loadingHide = true}) {
    const ipType = (state.selPolicyTab === 'ipv4') ? 1 : 2
    const uri = `${state.url}/${pid}/queues/${qid}/fw/${ipType}/devices`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSQueueFirewallSetList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // [Queue에 포함된 목록] (하위 목록) 조회
  async getQoSQueueFirewallList ({ commit, state }, {pid, qid, did, loadingShow = true, loadingHide = true}) {
    const ipType = (state.selPolicyTab === 'ipv4') ? 1 : 2
    const uri = `${state.url}/${pid}/queues/${qid}/fw/${ipType}/devices/${did}`
    try {
      const data = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      return resultFactory(commit, {length: null, data: data, action: 'getQoSQueueFirewallList', param: null})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // [Queue에 포함된 목록] 테이블에 추가
  async addQoSQueueFirewall ({ commit, state }, {pid, did, cData, payload, loadingShow = true, loadingHide = true, successAlert = true}) {
    let isMulty = false
    const idList = []
    const rid = payload[0].fw_rule_id
    const cid = cData.qos_class_id
    const multyUrl = `${state.url}/${pid}/fw/devices/${did}/rules`
    const singleUrl = `${state.url}/${pid}/fw/devices/${did}/rules/${rid}`
    let resultData = {}
    let actionName = ''
    if (payload.length > 1) {
      isMulty = true
      _.forEach(payload, item => {
        idList.push({'fw_rule_id': item.fw_rule_id})
      })
      resultData = {fw_rule_id_list: idList, qos_class_name: cData.qos_class_name}
      actionName = 'addQoSQueueFirewallList'
    } else {
      resultData = {rid: rid, qos_class_id: cid, qos_class_name: cData.qos_class_name}
      actionName = 'addQoSQueueFirewall'
    }
    try {
      const data = isMulty ? await this.$axios.$put(multyUrl, {fw_rule_id_list: idList, qos_class_id: cid}, {loadingShow: loadingShow, loadingHide: loadingHide, successAlert: successAlert})
        : await this.$axios.$put(singleUrl, {qos_class_id: cid}, {loadingShow: loadingShow, loadingHide: loadingHide, successAlert: successAlert})
      return resultFactory(commit, {length: idList.length, data: data, action: actionName, param: resultData})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  },
  // [Queue에 포함된 목록] 삭제
  async delQoSQueueFirewall ({ commit, state }, {pid, did, cid, payload, loadingShow = true, loadingHide = true, successAlert = true}) {
    let isMulty = false
    const idList = []
    const rid = payload[0].fw_rule_id
    const multyUrl = `${state.url}/${pid}/fw/devices/${did}/rules`
    const singleUrl = `${state.url}/${pid}/fw/devices/${did}/rules/${rid}`
    if (payload.length > 1) {
      isMulty = true
    }
    try {
      const data = isMulty ? await this.$axios.$delete(multyUrl, {data: {fw_rule_id_list: payload}}, {loadingShow: loadingShow, loadingHide: loadingHide, successAlert: successAlert})
        : await this.$axios.$delete(singleUrl, {loadingShow: loadingShow, loadingHide: loadingHide, successAlert: successAlert})
      return resultFactory(commit, {length: idList.length, data: data, action: 'delQoSQueueFirewall', param: payload})
    } catch (error) {
      return {code: 'error', errors: error.message}
    }
  }
}
